import {
  LinkNavigationProvider,
  type LinkComponentProps,
} from '@evisort/eds/context/LinkNavigation/LinkNavigation';
import { forwardRef, type ReactNode } from 'react';
import { Link } from 'react-router';

/**
 * Renders an in-app href as a react-router `<Link>`, so the router applies the
 * `/:client` basename (see `AppDataRouter`) to the `href` it puts in the DOM
 * through the same `useHref` path it navigates through. A hand-built anchor
 * emitted a basename-less `/documents`, which worked on a plain click but sent
 * cmd-click and copy-link to a URL the app read as a different tenant.
 */
const RouterLink = forwardRef<HTMLAnchorElement, LinkComponentProps>(
  function RouterLink({ href, ...rest }, ref) {
    return <Link {...rest} ref={ref} to={href} />;
  },
);

/**
 * Bridges EDS 2.0 link-rendering components (`Button` with `href`, `Link`,
 * `Breadcrumb`, menu links) to react-router, keeping `packages/eds`
 * router-agnostic. Must render inside the router context.
 */
export function EdsLinkNavigationProvider({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <LinkNavigationProvider linkComponent={RouterLink}>
      {children}
    </LinkNavigationProvider>
  );
}
